var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMonitoringBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Monitoring-Copy-2",
    transform: "translate(-28.000000, -172.000000)",
    fill: "#06B2BC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Side-Bar",
    transform: "translate(-1.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Monitoring",
    transform: "translate(1.000000, 143.273429)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.2222222,14.7265711 L29.7777778,14.7265711 C28.8,14.7265711 28,15.5265711 28,16.5043489 L28,28.9487933 C28,29.9265711 28.8,30.7265711 29.7777778,30.7265711 L42.2222222,30.7265711 C43.2,30.7265711 44,29.9265711 44,28.9487933 L44,16.5043489 C44,15.5265711 43.2,14.7265711 42.2222222,14.7265711 Z M32.4444444,27.1710155 L32.4444444,27.1710155 C31.9555556,27.1710155 31.5555556,26.7710155 31.5555556,26.2821267 L31.5555556,23.61546 C31.5555556,23.1265711 31.9555556,22.7265711 32.4444444,22.7265711 C32.9333333,22.7265711 33.3333333,23.1265711 33.3333333,23.61546 L33.3333333,26.2821267 C33.3333333,26.7710155 32.9333333,27.1710155 32.4444444,27.1710155 Z M36,27.1710155 L36,27.1710155 C35.5111111,27.1710155 35.1111111,26.7710155 35.1111111,26.2821267 L35.1111111,25.3932378 C35.1111111,24.9043489 35.5111111,24.5043489 36,24.5043489 C36.4888889,24.5043489 36.8888889,24.9043489 36.8888889,25.3932378 L36.8888889,26.2821267 C36.8888889,26.7710155 36.4888889,27.1710155 36,27.1710155 Z M36,22.7265711 C35.5111111,22.7265711 35.1111111,22.3265711 35.1111111,21.8376822 C35.1111111,21.3487933 35.5111111,20.9487933 36,20.9487933 C36.4888889,20.9487933 36.8888889,21.3487933 36.8888889,21.8376822 C36.8888889,22.3265711 36.4888889,22.7265711 36,22.7265711 Z M39.5555556,27.1710155 L39.5555556,27.1710155 C39.0666667,27.1710155 38.6666667,26.7710155 38.6666667,26.2821267 L38.6666667,19.1710155 C38.6666667,18.6821267 39.0666667,18.2821267 39.5555556,18.2821267 C40.0444444,18.2821267 40.4444444,18.6821267 40.4444444,19.1710155 L40.4444444,26.2821267 C40.4444444,26.7710155 40.0444444,27.1710155 39.5555556,27.1710155 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoringBlue);
export default __webpack_public_path__ + "static/media/monitoring-blue.206dacd4c0b93330b6b7d6dde59a1d37.svg";
export { ForwardRef as ReactComponent };